import { Button } from '@breetometer/components';
import { PlusIcon } from 'BreetAssets';
import { BeneficiaryList } from 'BreetComponents';
import { type IBeneficiariesProps, type IBeneficiary } from 'BreetHelpers';
import { openModal, selectBeneficiaries, useAppDispatch, useAppSelector } from 'BreetRedux';
import { useCallback } from 'react';

const Beneficiaries = ({
	onAddNewBeneficiary,
	title,
	selectBeneficiary,
	selectedBeneficiaryId,
	onManageBeneficiaries,
	mode = 'select',
	filterOutType,
}: IBeneficiariesProps) => {
	const dispatch = useAppDispatch();

	const beneficiaries = useAppSelector(selectBeneficiaries);

	const filteredBeneficiaries = beneficiaries.filter((i) => i.type !== filterOutType);

	const selectedBeneficiary = filteredBeneficiaries.find((i) => i._id === selectedBeneficiaryId);

	const handleBeneficiarySelection = useCallback(
		(beneficiary: IBeneficiary, modeArg: 'delete' | 'select') => () => {
			if (modeArg === 'delete') {
				dispatch(
					openModal({
						id: 'deletebeneficiary',
						metadata: { id: beneficiary._id, isAutoSettlementBeneficiary: beneficiary.autoSettlement },
						hideCloseButton: true,
					})
				);
			} else {
				selectBeneficiary(beneficiary);
			}
		},
		[dispatch, selectBeneficiary]
	);

	const handleNewBeneficiary = useCallback(() => {
		selectBeneficiary(undefined);
		onAddNewBeneficiary?.();
	}, [onAddNewBeneficiary, selectBeneficiary]);

	const isMaxBeneficiaries = filteredBeneficiaries.length === 3;

	return (
		<div
			className='payment-request-form_beneficiarysection'
			data-testid='beneficiaries'
		>
			<BeneficiaryList
				title={title}
				beneficiaries={filteredBeneficiaries}
				handleBeneficiarySelection={handleBeneficiarySelection}
				selectedBeneficiaryId={selectedBeneficiary?._id}
				mode={mode}
				hideHeader={mode === 'delete'}
				key={filterOutType}
			/>

			{mode === 'select' ? (
				<div className='payment-request-form_beneficiarysectioncta'>
					{!isMaxBeneficiaries && (
						<Button
							label='Add Account'
							variant='primary'
							type='button'
							onClick={handleNewBeneficiary}
							className='add-new-btn bg-primary-400-hover color-neutral-50-hover tertiary-semi-hover'
						/>
					)}
					<Button
						label='Manage Accounts'
						variant='tertiary'
						type='button'
						onClick={onManageBeneficiaries}
						className='manage-btn theme-background-none border-dark-navy color-tertiary-400 bg-primary-400-hover color-neutral-50-hover tertiary-semi-hover'
					/>
				</div>
			) : (
				!isMaxBeneficiaries && (
					<div className='managebeneficiary_cta'>
						<Button
							leadingIcon={<PlusIcon className='addaccounticon' />}
							label='Add Account'
							variant='tertiary'
							onClick={handleNewBeneficiary}
							className='tertiary-semi-hover'
						/>
					</div>
				)
			)}
		</div>
	);
};

export default Beneficiaries;
